/**
 * Shopify Integration Module (Story 12.4)
 *
 * Barrel export for all Shopify OAuth and adapter modules.
 * Single platform: shopify.
 *
 * Key characteristics:
 * - Store URL pre-input required (auth URL is store-specific)
 * - HMAC callback validation (unique to Shopify)
 * - No refresh tokens (permanent offline access tokens)
 * - Single account per token (1 store = 1 OAuth token)
 * - ShopifyQL for analytics data
 */

import { registerAdapter } from "../registry";
import { shopifyAdapter } from "./shopify";

// Register Shopify adapter (Story 12.4)
registerAdapter("shopify", shopifyAdapter);

// Platform values (shared constant for frontend/backend alignment)
export const SHOPIFY_PLATFORM_VALUES = ["shopify"] as const;
export type ShopifyPlatform = (typeof SHOPIFY_PLATFORM_VALUES)[number];

export const SHOPIFY_OAUTH_PLATFORM_VALUES = ["shopify"] as const;

// OAuth utilities
export {
  buildShopifyAuthUrl,
  exchangeShopifyCode,
  verifyShopifyHmac,
  validateShopDomain,
  validateCallbackTimestamp,
  fetchShopInfo,
  parseShopifyCallbackError,
  SHOPIFY_API_VERSION,
  SHOP_DOMAIN_REGEX,
  SHOPIFY_SCOPES,
  type ShopifyAuthUrlOptions,
  type ShopifyTokenResponse,
  type ShopifyShopInfo,
  type ShopifyCallbackError,
} from "./oauth";

// Shopify Adapter
export {
  shopifyAdapter,
  SHOPIFY_METRICS,
  SHOPIFY_DIMENSIONS,
} from "./shopify";
